import PlantsCatalogSkeleton from "./PlantsCatalogSkeleton";

export function PlantsPageLoading() {
  return <PlantsCatalogSkeleton />;
}
